module.exports = __webpack_public_path__ + "img/PODRA.a2625ee2.png";